import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const splitListMetricsItemSchema_ = z.object({
  splitId: zExt.objectId(),
  testDurationDays: z.number().optional(),
  visits: z.number().optional(),
  revenueImpact: z.string().optional(),
  conversionRateOfWinningTreatment: z.string().optional(),
  aovOfWinningTreatment: z.string().optional(),
});
export interface SplitListMetricsItem
  extends z.infer<typeof splitListMetricsItemSchema_> {}

export const getCheckoutSplitListMetrics = {
  name: "getCheckoutSplitListMetrics" as const,
  input: z.object({ splitIds: z.array(zExt.objectId()) }),
  output: z.array(splitListMetricsItemSchema_),
};
